import { View, StyleSheet } from '@react-pdf/renderer';

const style = StyleSheet.create({
  pdfDetailsStyle: {
    width: '100%',
    marginBottom: '20px',

    display: 'flex',
    flexDirection: 'column',

    fontSize: '10px',
  },
});

export const PdfDetails: React.FC = ({ ...props }) => (
  <View style={style.pdfDetailsStyle}>{props.children}</View>
);
